<template>
  <div>
    <el-timeline-item
      v-if="content"
      :icon="icon"
      :type="type"
      :color="color"
      size="large"
      :timestamp="formatDate(activity.createdOn)"
    >
      <div v-html="formattedActivityText" class=""></div>
    </el-timeline-item>
  </div>
</template>

<script>
import ActivitiesTimelineMixin from "@/components/ActivitiesView/ActivitiesTimelineMixin.vue";
export default {
  mixins: [ActivitiesTimelineMixin],
  props: {
    activity: {
      type: Object,
      required: true
    },
    documentCategories: {
      type: Object,
      required: false
    }
  },
  watch: {
    activity: {
      async handler() {
        this.content = "";
        this.icon = "";
        this.type = "";
        this.link = {};
        this.color = "";
        switch (this.activity.name) {
          case "DELETE_DOCUMENT_CATEGORY_SUCCESS":
            this.generateReadableGeneric({
              content: `deleted a document category`,
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "DELETE_DOCUMENT_CATEGORY_FAILURE":
            this.generateReadableFailGeneric({
              content: `failed to delete document category`,
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "CREATE_DOCUMENT_CATEGORY_SUCCESS":
            this.generateReadableGeneric({
              content: `created a document category titled ${this?.activity?.data?.title}`,
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "CREATE_DOCUMENT_CATEGORY_FAILURE":
            this.generateReadableFailGeneric({
              content: `failed to create document category`,
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "UPDATE_DOCUMENT_CATEGORY_SUCCESS":
            this.generateReadableGeneric({
              content: `updated a document category`,
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "UPDATE_DOCUMENT_CATEGORY_FAILURE":
            this.generateReadableFailGeneric({
              content: `failed to update document category`,
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
        }
      },
      immediate: true
    }
  }
};
</script>
